module.exports = __webpack_public_path__ + "img/mask-icon.eb446ebc.svg";